export default "__VITE_ASSET__DhpJMmek__"